import { useMutation, useQueryClient } from '@tanstack/react-query'
import { profile } from '@myap/ui-library'
import { putRequest } from '../utils/fetchOperations'
import { SCORE_SEND_KEY } from '../components/_common/reactquery'

const useSaveStudentScoreSendMutation = ({
  educationPeriodCd,
  studentId,
  diCode,
  org,
  optOut = false,
}) => {
  const queryClient = useQueryClient()
  const { apiUrl } = profile()
  return useMutation({
    mutationKey: [SCORE_SEND_KEY, educationPeriodCd, studentId],
    mutationFn: async ({ signal }) => {
      return await putRequest({
        url: `${apiUrl}/score-send-di/education-period-cd/${educationPeriodCd}/studentId/${studentId}`,
        payload: { diCode, optOut },
        signal,
      })
    },
    onSuccess: ({ diCode, userPromptType }, variables) => {
      queryClient.setQueryData([SCORE_SEND_KEY, educationPeriodCd, studentId], oldData => ({
        ...oldData,
        diCode,
        userPromptType,
        optOut,
        org,
      }))
    },
  })
}

export default useSaveStudentScoreSendMutation
